import { useState, useEffect } from 'react';
import { TourType } from '@/components/help/PlatformTour';

export function usePlatformTour() {
  const [activeTour, setActiveTour] = useState<TourType | null>(null);
  const [runTour, setRunTour] = useState(false);

  const startTour = (tourType: TourType) => {
    setActiveTour(tourType);
    setRunTour(true);
  };

  const completeTour = () => {
    setRunTour(false);
    setActiveTour(null);
  };

  const hasCompletedTour = (tourType: TourType): boolean => {
    const completedTours = JSON.parse(localStorage.getItem('completedTours') || '[]');
    return completedTours.includes(tourType);
  };

  // Auto-start dashboard tour for new users (on dashboard page)
  useEffect(() => {
    const isNewUser = !localStorage.getItem('hasSeenDashboardTour');
    const currentPath = window.location.pathname;

    if (isNewUser && currentPath === '/dashboard') {
      const timer = setTimeout(() => {
        startTour('dashboard');
        localStorage.setItem('hasSeenDashboardTour', 'true');
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  return {
    activeTour,
    runTour,
    startTour,
    completeTour,
    hasCompletedTour,
  };
}
